// extracted by extract-css-chunks-webpack-plugin
module.exports = {"barcodeDetails":"tCBhA","couponInfo":"sa0R-","couponOffInfo":"h0bPs","showCouponDesc":"IEcjo","barcode":"hFiNH","inlinBarCode":"_4uERl","barcodeMessage":"_9et1L"};